import {Component} from '@angular/core';

@Component({
    selector: 'portrait-block-component',
    templateUrl: './portrait-block.component.html',
    styleUrls: ['./portrait-block.component.scss']
})
export class PortraitBlockComponent {

    constructor() {
    }

}






// WEBPACK FOOTER //
// ./src/app/components/portrait-block/portrait-block.component.ts